export default "__VITE_ASSET__7d9b3f33__"